import { Pipe, PipeTransform } from '@angular/core';

import { DiscussionListItem } from '../models/discussion.models';

@Pipe({
  name: 'overdue',
})
export class OverduePipe implements PipeTransform {
  transform(discussion: DiscussionListItem): boolean {
    if (!discussion.dueDate) return false;
    return (
      !discussion.isDone &&
      !discussion.isCompleted &&
      !discussion.isMeetingCompleted &&
      new Date(discussion.dueDate) < new Date()
    );
  }
}
